/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Kullanim_S11_HeadingInputs */

const tr_kullanim_s11_heading = /** @type {(inputs: Kullanim_S11_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`11. Müşteri İçeriği ve Veri Mülkiyeti`)
};

const en_kullanim_s11_heading = /** @type {(inputs: Kullanim_S11_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`11. Customer content and data ownership`)
};

const de_kullanim_s11_heading = /** @type {(inputs: Kullanim_S11_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`11. Kundeninhalte und Dateneigentum`)
};

const ru_kullanim_s11_heading = /** @type {(inputs: Kullanim_S11_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`11. Контент клиента и право собственности на данные`)
};

/**
* | output |
* | --- |
* | "11. Customer content and data ownership" |
*
* @param {Kullanim_S11_HeadingInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const kullanim_s11_heading = /** @type {((inputs?: Kullanim_S11_HeadingInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Kullanim_S11_HeadingInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_kullanim_s11_heading(inputs)
	if (locale === "de") return de_kullanim_s11_heading(inputs)
	if (locale === "ru") return ru_kullanim_s11_heading(inputs)
	return tr_kullanim_s11_heading(inputs)
});